import { createSelector } from 'reselect';
import { getValue } from '@truqc/content-path';
import { convertToAbsolutePath } from '../utils';
import { getContent, getFormatContentPath } from './simpleSelectors';
const getParentContentPath = (state, props) => props.parentContentPath;
const getEnabled = (state, props) => props.enabled;
const getFormatEnabledContentPaths = (state, props) => {
  const _props$format = props.format,
    format = _props$format === void 0 ? {} : _props$format;
  return format.enabledContentPaths;
};
const getFormatEnabledValues = (state, props) => {
  const _props$format2 = props.format,
    format = _props$format2 === void 0 ? {} : _props$format2;
  return format.enabledValues;
};

/**
 * Gets the value at the end of the provided content path and ensures
 * it matches the provided value
 * @param {Array} valueList - List of content path / value pairs
 * @param {Object} content - content to traverse
 */
const disabledByValues = (valueList, content, path) => valueList.some(_ref => {
  let contentPath = _ref.contentPath,
    value = _ref.value;
  const valueAtPath = getValue(convertToAbsolutePath(contentPath, path), content);
  return valueAtPath !== value;
});

/**
 * Searches for content at the end of each provided content path
 * @param {Array} pathList - list of content paths
 * @param {Object} content - content to traverse
 */
const disabledByPaths = (pathList, content, path) => pathList.some(contentPath => {
  const valueAtPath = getValue(convertToAbsolutePath(contentPath, path), content);
  return typeof valueAtPath === 'undefined' || valueAtPath === null;
});
export default createSelector([getContent, getFormatEnabledValues, getFormatEnabledContentPaths, getEnabled, getFormatContentPath, getParentContentPath], (content, enabledValues, enabledContentPaths, enabled, contentPath, parentContentPath) => {
  // const safePath = extractCurrentPath(path, contentPath);

  let isEnabled = true;
  if (enabledValues) {
    // isEnabled = isEnabled && !disabledByValues(enabledValues, content, safePath);
    isEnabled = isEnabled && !disabledByValues(enabledValues, content, parentContentPath);
  }
  if (enabledContentPaths) {
    // isEnabled = isEnabled && !disabledByPaths(enabledContentPaths, content, safePath);
    isEnabled = isEnabled && !disabledByPaths(enabledContentPaths, content, parentContentPath);
  }
  if (typeof enabled === 'boolean') {
    isEnabled = isEnabled && enabled;
  }
  return isEnabled;
});